import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Select, Modal } from 'components';
import { TrashIcon, EditIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon, CalendarWhite, TimeIcon, Menu as MenuIcons } from 'assets/icons';
import { Globals, checkPermission, Constants, Colors } from 'utils';
import CreateService from './create-service';
import { ServiceService } from 'services';
import ModalCalendar from './modal-calendar';
import ModalUrgent from './modal-urgent';
import ModalCalendarSpecial from './modal-calendar-special';
import ModalPriceMeter from 'screens/admin/modal-price-meter';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	status: ''
}

class Services extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nombre',
			// 'Superficie',
			'Precio',
			'Estatus',
			'Acciones'
		],
		visible: false,
		item: null,
		visible_change_status: false,
		visible_confirm_change_status: false,
		visible_confirm: false, 
		visible_delete: false,
		visible_calendar: false,
		journeys: [],
		visible_bulk_confirm: false, 
		visible_bulk_delete: false,
		visible_urgent: false,
		visible_price_meter: false,
		visible_calendar_special: false,
		types: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Servicios',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
		this.loadJourneys();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ServiceService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.services.rows,
			last_page: res.services.count
		});
	}

	loadJourneys = async () => {
		const res: any = await ServiceService.admin.getJourneys({
			withoutLoading: true
		});
		this.setState({
			journeys: res.journeys || [],
			types: res.types || []
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	confirmDelete = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_confirm: true,
			item
		});
	}

	delete = async () => {
		const item: any = this.state.item;
		await ServiceService.admin.delete({
			service_id: item.id
		});
		await this.setState({
			visible_delete: true,
			visible_confirm: false,
			item: null
		});
		this.load(true);
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	bulkDelete = async () => {
		await ServiceService.admin.bulkDelete({
			service_ids: this.state.data.filter((i: any) => i.active).map((i: any) => i.id),
		});
		await this.setState({
			visible_bulk_delete: true,
			visible_bulk_confirm: false
		});
		this.load(true);
	}

	confirmBulkDelete = () => {
		this.setState({
			visible_bulk_confirm: true
		});
	}

	setActive = (index: number) => {
		let data: any = [...this.state.data];
		data[index].active = !data[index].active;
		this.setState({
			data
		});
	}

	setAllActive = () => {
		let data: any = [...this.state.data];
		if (data.filter((i: any) => i.active).length == data.length) {
			data.map((i: any) => {
				i.active = false;
				return i;
			});
		}
		else {
			data.map((i: any) => {
				if (!i.active) {
					i.active = true;
				}
				return i;
			});
		}
		this.setState({
			data
		});
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	onCloseConfirm = () => {
		this.setState({
			visible_confirm: false
		});
	}

	onCloseDelete = () => {
		this.setState({
			visible_delete: false
		});
	}

	onCloseChangeStatus = () => {
		this.setState({
			visible_change_status: false
		});
	}

	onCloseConfirmStatus = () => {
		this.setState({
			visible_confirm_change_status: false
		});
	}

	changeStatus = async () => {
		const item: any = this.state.item;
		await ServiceService.admin.changeStatus({
			service_id: item.id
		});
		await this.setState({
			visible_change_status: true,
			visible_confirm_change_status: false,
			item: null
		});
		this.load(true);
	}

	confirmChangeStatus = async (item: any) => {
		this.setState({
			visible_confirm_change_status: true,
			item
		});
	}

	getColor = (service: any) => {
		switch(service.status) {
			case Constants.SERVICE_STATUS.ACTIVE:
				return Colors.green;
			break;

			case Constants.SERVICE_STATUS.INACTIVE:
				return Colors.danger;
			break;
		}
	}

	calendar = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			item,
			visible_calendar: true
		});
	}

	calendarSpecial = () => {
		this.setState({
			visible_calendar_special: true
		});
	}

	urgent = () => {
		this.setState({
			visible_urgent: true
		});
	}

	onCloseCalendar = () => {
		this.setState({
			item: null,
			visible_calendar: false
		});
	}

	onCloseCalendarSpecial = () => {
		this.setState({
			visible_calendar_special: false
		});
	}

	onCloseUrgent = () => {
		this.setState({
			visible_urgent: false
		});
	}

	onCloseBulkDelete = () => {
		this.setState({
			visible_bulk_delete: false
		});
	}

	onCloseBulkConfirm = () => {
		this.setState({
			visible_bulk_confirm: false
		});
	}

	onClosePriceMeter = () => {
		this.setState({
			visible_price_meter: false
		});
	}

	deep = () => {
		this.setState({
			visible_price_meter: true
		});
	}
	
	render() {
		const { visible_calendar_special, visible_price_meter, visible_urgent, visible, visible_confirm, visible_delete, visible_change_status, visible_confirm_change_status, visible_calendar, visible_bulk_confirm, visible_bulk_delete } = this.state;
		const item: any = this.state.item;

		return (
			<div id="services">
				<BackComponent />

				<Modal
		          className="modal-calendar-bookings"
		          visible={ visible_calendar }
		          title=""
		          centered
		          onClose={ () => this.onCloseCalendar() }
		        >
		          <ModalCalendar
		          	item={ this.state.item }
		            onClose={ () => this.onCloseCalendar() } />
		      	</Modal>

		      	<Modal
		          className="modal-calendar-bookings"
		          visible={ visible_calendar_special }
		          title=""
		          centered
		          onClose={ () => this.onCloseCalendarSpecial() }
		        >
		          <ModalCalendarSpecial
		            onClose={ () => this.onCloseCalendarSpecial() } />
		      	</Modal>

		      	<Modal
		          className="modal-service-urgent"
		          visible={ visible_urgent }
		          title="Servicio Urgente"
		          centered
		          onClose={ () => this.onCloseUrgent() }
		        >
		          <ModalUrgent
		            onClose={ () => this.onCloseUrgent() } />
		      	</Modal>

		      	<Modal
		          className="modal-exchange"
		          visible={ visible_price_meter }
		          title="Actualizar precio"
		          centered
		          onClose={ () => this.onClosePriceMeter() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalPriceMeter
		          	onClose={ () => this.onClosePriceMeter() }
		          />
		      	</Modal>

				<div className={ `container-modal-right ${ visible ? 'active' : '' }` }>
					{
						visible && (
							<CreateService
								item={ this.state.item }
								journeys={ this.state.journeys }
								title="Datos del Servicio"
								onClose={ () => this.onClose() }
								types={ this.state.types }
							/>
						)
					}
				</div>

				<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_confirm }
		          title=""
		          centered
		          onClose={ () => this.onCloseConfirm() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de eliminar al servicio?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.delete() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_confirm: false,
										item: null
									});
								} }>
									Cancelar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_delete }
		          title=""
		          centered
		          onClose={ () => this.onCloseDelete() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se ha eliminado con éxito</h3>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_bulk_confirm }
		          title=""
		          centered
		          onClose={ () => this.onCloseBulkConfirm() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de eliminar los servicios seleccionados?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.bulkDelete() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_bulk_confirm: false
									});
								} }>
									Cancelar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_bulk_delete }
		          title=""
		          centered
		          onClose={ () => this.onCloseBulkDelete() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se han eliminado con éxito</h3>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_confirm_change_status }
		          title=""
		          centered
		          onClose={ () => this.onCloseConfirmStatus() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de { item?.status == Constants.SERVICE_STATUS.ACTIVE ? 'inactivar' : 'activar' } este servicio?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.changeStatus() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_confirm_change_status: false,
										item: null
									});
								} }>
									Cancelar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_change_status }
		          title=""
		          centered
		          onClose={ () => this.onCloseChangeStatus() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se ha cambiado el estatus con éxito</h3>
					</div>
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-7">
						<div className="row">
							<div className="col-md-5">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Nombre"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-5">
								<Select
									placeholder="Estatus"
									name="status"
									onChange={ (e: any) => this.change(e,() => {
										this.load(true);
									}) }
									value={ this.state.form.status }
									options={ [
										{ value: Constants.SERVICE_STATUS.ACTIVE.toString(), label: 'Activos' },
										{ value: Constants.SERVICE_STATUS.INACTIVE.toString(), label: 'Inactivos' },
									] } />
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-5 text-right">
						{
							checkPermission(Constants.MODULES.SERVICES,'delete') && this.state.data.filter((i: any) => i.active).length > 0 && (
								<button className="btn btn-delete" onClick={ () => this.confirmBulkDelete() }>
									<img src={ TrashWhiteIcon } />
									Eliminar
								</button>
							)
						}
						{
							checkPermission(Constants.MODULES.SERVICES,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
					<div className="col-md-7" style={{ marginBottom: '15px' }}>
						{
							checkPermission(Constants.MODULES.SERVICES,'write') && (
								<button className="btn btn-calendar" style={{ marginLeft: '0px' }} onClick={ () => this.deep() }>
									<img src={ MenuIcons.MenuPriceMeter } />
									Limpieza Profunda
								</button>
							)
						}
						{
							checkPermission(Constants.MODULES.SERVICES,'write') && (
								<button className="btn btn-calendar" onClick={ () => this.urgent() }>
									<img src={ TimeIcon } />
									Servicio Urgente
								</button>
							)
						}
						{
							checkPermission(Constants.MODULES.SERVICES,'write') && (
								<button className="btn btn-calendar" onClick={ () => this.calendarSpecial() }>
									<img src={ CalendarWhite } />
									Días con recargo
								</button>
							)
						}
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header } childrenHeader={
					<th>
						{
							checkPermission(Constants.MODULES.SERVICES,'delete') && (
								<CheckboxTable 
									active={ this.state.data.filter((i: any) => i.active).length == this.state.data.length } 
									onClick={ () => this.setAllActive() } />
							)
						}
					</th>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>
									{
										checkPermission(Constants.MODULES.SERVICES,'delete') && (
											<CheckboxTable 
												active={ i.active } 
												onClick={ () => this.setActive(index) } />
										)
									}
								</td>
								<td>{ i.name }</td>
								{/*<td>
									{
										i.service_prices.map((i: any) => {
											return (
												<p>{ i?.name }</p>
											)
										})
									}
								</td>*/}
								<td>
									{/*{
										i.service_prices.map((i: any) => {
											return (
												<p>{ Globals.formatMiles(i.price) }</p>
											)
										})
									}*/}
									<p><strong>Detal:</strong>{ Globals.formatMiles(i.price) }</p>
									<p><strong>Mayor:</strong>{ Globals.formatMiles(i.price_corporate) }</p>
								</td>
								<td>
									<p className="container-color" onClick={ () => this.confirmChangeStatus(i) } style={{
										color: this.getColor(i)
									}}>
										{ i.status_text }
									</p>
								</td>
								<td>
									{
										checkPermission(Constants.MODULES.SERVICES,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.SERVICES,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.confirmDelete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.SERVICES,'write') && (
											<Tooltip title="Calendario laboral">
												<a className="link-icon" href="#" onClick={ (e: any) => this.calendar(e,i) }>
													<img src={ CalendarWhite } className="calendar-icon" />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(Services);